import styled from 'styled-components';
import { VideoHeadingInnerStyle } from 'components/VideoHeading/VideoHeadingLayout/VideoHeadingLayout.style';
import { CarouselWrapperStyle } from 'components/Lists/Carousel/Carousel.style';
import { SkeletonProgramItemStyle } from 'components/SkeletonElement/SkeletonElement.style';
import { LayoutStyle } from '../Layout/Layout.style';
import { Heading2 } from '../Text/Text.style';
import { TileListStyle } from '../Lists/TileList/TileList.style';

export const MoviesWrapperStyle = styled.div<{ isHeaderHidden: boolean }>`
  ${VideoHeadingInnerStyle} {
    @media (max-width: ${props => props.theme.breakpoints.smMax}) {
      transition: transform ${props => props.theme.transitions.easeIn};
      transform: ${props => (props.isHeaderHidden ? 'translateY(-56px)' : 'none')};
    }
  }
`;

export const MoviesSectionWrapperStyle = styled(LayoutStyle)`
  padding: 30px 0;

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    padding: 30px 0;
  }

  @media (min-width: ${props => props.theme.breakpoints.lgMin}) {
    padding: 30px 0;
  }

  ${Heading2} {
    margin-bottom: 16px;
  }

  ${CarouselWrapperStyle} {
    margin-bottom: 42px;
  }

  ${TileListStyle} {
    grid-row-gap: 16px;
    margin-top: 8px;
    margin-bottom: 42px;

    @media (min-width: ${props => props.theme.breakpoints.lgMin}) {
      grid-row-gap: 24px;
    }
  }

  ${SkeletonProgramItemStyle} {
    margin-left: 0;
  }
`;

export const MoviesAdStyle = styled.div`
  padding: 0;
`;
